/**
 * jQuery Toogle Navigation
 */
(function($){
    $.fn.responsiveDesign = function(){
        
        // Responsive handling
        function responsiveHandling() {
            var browserWidth = $(window).width();
            
            // Responsive nav
            if ( (browserWidth) < 768 ) {
                $('.responsiveNavToggle').unbind('click').click(function(){
                    $(this).find('.fa').toggleClass('fa-bars').toggleClass('fa-times');
                    $('#navMain').slideToggle();
                    return false;
                });
            } else {
                $('#navMain').show();
            }

            // set a class if window width is < X and > Y
            if ((browserWidth) < 1700 && (browserWidth) > 1200){
                $('body').addClass("responsiveST1700");
                $('body').removeClass("responsiveST1200");
            } else if((browserWidth) < 1200 && (browserWidth) > 1080) {
                $('body').addClass("responsiveST1200");
                $('body').removeClass("responsiveST1700 responsiveST1080 responsive");
            } else if((browserWidth) < 1080 && (browserWidth) > 768) {
                $('body').addClass("responsiveST1080");
                $('body').removeClass("responsiveST1200 responsive");
            } else if((browserWidth) < 768) {
                $('body').addClass("responsive");
                $('body').removeClass("responsiveST1080");
            } else {
                $('body').removeClass("responsive responsiveST1700 responsiveST1200 responsiveST1080");
            }
        }

        // Autostart function
        responsiveHandling();
    };
})(jQuery);